/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initHubspot } from './utils/initHubspot';
import { initHeap } from './utils/initHeap';
import { initGTM } from './utils/initGTM';

initHubspot();
initHeap();
initGTM();

const root = ReactDOM.createRoot(window.document.getElementById('root'));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
